import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["height", "width", "datasetIdKey", "type", "data", "options", "plugins"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Temporary patch of react-chartjs-2 Chart component to
// fix animation rendering issues.  This file should be deprecated
// Once Chrome is able to render smooth area charts without issue
import React, { useEffect, useRef, forwardRef } from 'react';
import { Chart as ChartJS, LineController } from 'chart.js';
import { jsx as _jsx } from "react/jsx-runtime";

function ChartComponent(props, ref) {
  const _ref = props,
        {
    height = 150,
    width = 300,
    datasetIdKey,
    type,
    data,
    options,
    plugins = []
  } = _ref,
        canvasProps = _objectWithoutProperties(_ref, _excluded);

  const canvasRef = useRef(null);
  const chartRef = useRef();

  const renderChart = () => {
    if (!canvasRef.current) return; // Fix rendering issue with Area background color
    // https://github.com/chartjs/Chart.js/issues/11310#issuecomment-2490765111

    canvasRef.current.getContext('2d', {
      willReadFrequently: true
    });
    chartRef.current = new ChartJS(canvasRef.current, {
      type,
      data: cloneData(data, datasetIdKey),
      options: options && _objectSpread({}, options),
      plugins
    }); // @ts-expect-error - type mismatch

    reforwardRef(ref, chartRef.current);
  };

  const destroyChart = () => {
    reforwardRef(ref, null);

    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };

  useEffect(() => {
    if (chartRef.current && options) {
      setOptions(chartRef.current, options);
    }
  }, [options]);
  useEffect(() => {
    if (chartRef.current) {
      setLabels(chartRef.current.config.data, data.labels);
    }
  }, [data.labels]);
  useEffect(() => {
    if (chartRef.current && data.datasets) {
      setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }
  }, [data.datasets, datasetIdKey]);
  useEffect(() => {
    if (!chartRef.current) return;
    chartRef.current.update();
  }, [options, data.labels, data.datasets]);
  useEffect(() => {
    if (!chartRef.current) return;
    destroyChart();
    setTimeout(renderChart); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);
  useEffect(() => {
    renderChart();
    return () => destroyChart(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx("canvas", _objectSpread({
    ref: canvasRef,
    role: "img",
    height: height,
    width: width
  }, canvasProps));
}

const defaultDatasetIdKey = 'label';
export function reforwardRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
export function setOptions(chart, nextOptions) {
  const options = chart.options;

  if (options && nextOptions) {
    Object.assign(options, nextOptions);
  }
}
export function setLabels(currentData, nextLabels) {
  currentData.labels = nextLabels;
}
export function setDatasets(currentData, nextDatasets) {
  let datasetIdKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultDatasetIdKey;
  const addedDatasets = [];
  currentData.datasets = nextDatasets.map(nextDataset => {
    // given the new set, find it's current match
    const currentDataset = currentData.datasets.find(dataset => dataset[datasetIdKey] === nextDataset[datasetIdKey]); // There is no original to update, so simply add new one

    if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
      return _objectSpread({}, nextDataset);
    }

    addedDatasets.push(currentDataset);
    Object.assign(currentDataset, nextDataset);
    return currentDataset;
  });
}
export function cloneData(data) {
  let datasetIdKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDatasetIdKey;
  const nextData = {
    labels: [],
    datasets: []
  };
  setLabels(nextData, data.labels);
  setDatasets(nextData, data.datasets, datasetIdKey);
  return nextData;
} // Get dataset from mouse click event

export function getDatasetAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
    intersect: true
  }, false);
} // Get single dataset element from mouse click event

export function getElementAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
    intersect: true
  }, false);
} // Get all dataset elements from mouse click event

export function getElementsAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
    intersect: true
  }, false);
}
const BaseChart = /*#__PURE__*/forwardRef(ChartComponent);

function createTypedChart(type, registerables) {
  ChartJS.register(registerables);
  return /*#__PURE__*/forwardRef(function render(props, ref) {
    return /*#__PURE__*/_jsx(BaseChart, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      type: type
    }));
  });
}

export const TmpLineChartJs = createTypedChart('line', LineController);